import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { resizeImage } from '../utils/imageUtils';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import './ToolPage.css';

const ImageResize = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [width, setWidth] = useState(800);
    const [height, setHeight] = useState(600);
    const [maintainAspect, setMaintainAspect] = useState(true);
    const [processedFiles, setProcessedFiles] = useState([]);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFiles([]);
    };

    const handleResize = async () => {
        if (files.length === 0) return;

        setProcessing(true);
        const resized = [];

        try {
            for (const file of files) {
                const resizedFile = await resizeImage(file, width, height, maintainAspect);
                resized.push(resizedFile);
            }
            setProcessedFiles(resized);
        } catch (error) {
            alert('Resize failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const handleDownload = async () => {
        if (processedFiles.length === 1) {
            saveAs(processedFiles[0], processedFiles[0].name);
        } else {
            const zip = new JSZip();
            processedFiles.forEach((file) => {
                zip.file(file.name, file);
            });
            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, 'resized_images.zip');
        }
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>📐 Image Resize</h1>
                <p>Adjust image dimensions, supports maintaining aspect ratio</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="image/*"
                    onFilesSelected={handleFilesSelected}
                    title="Upload Images"
                />

                {files.length > 0 && !processing && processedFiles.length === 0 && (
                    <div className="tool-controls">
                        <div className="size-inputs">
                            <div className="input-group">
                                <label>Width (px)</label>
                                <input
                                    type="number"
                                    value={width}
                                    onChange={(e) => setWidth(parseInt(e.target.value) || 0)}
                                    className="size-input"
                                />
                            </div>
                            <div className="input-group">
                                <label>Height (px)</label>
                                <input
                                    type="number"
                                    value={height}
                                    onChange={(e) => setHeight(parseInt(e.target.value) || 0)}
                                    className="size-input"
                                />
                            </div>
                        </div>
                        <div className="checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={maintainAspect}
                                    onChange={(e) => setMaintainAspect(e.target.checked)}
                                />
                                Maintain Aspect Ratio
                            </label>
                        </div>
                        <button className="btn btn-primary" onClick={handleResize}>
                            Resize
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Resizing images..." />}

                {processedFiles.length > 0 && (
                    <div className="results">
                        <h3>Processing Complete!</h3>
                        <p>Successfully resized {processedFiles.length} image(s)</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            {processedFiles.length === 1 ? 'Download' : 'Download All'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageResize;
